import { defineStore } from 'pinia'
import ArrivalService from "@/services/arrival.service.js";
export const useArrivalStore = defineStore('arrival', {
    state: () => {
        return {
            arrivals: [],
            arrival: null,
            paginate: {},
            lastPage: 1,
        }
    },
    persist: true,
    actions: {
        async getListArrivalsWithLimit(url, params) {
            try {
                const res = await ArrivalService.getListArrivals(url, params)
                this.arrivals = res.data.data
                this.paginate = res.data.meta
                this.lastPage = res.data.meta.page
            } catch (e) {
                return null
            }
        },
        async getArrivalDetail(url, params) {
            try {
                const res = await ArrivalService.getArrivalDetail(url, params)
                this.arrival = res.data
            } catch (e) {
                return null
            }
        },
        async changeStatusArrival(url, params) {
            try {
                const res = await ArrivalService.changeStatusArrival(url, params)
                return res.data;
            } catch (e) {
                return e;
            }
        },
        async cancelArrival(url, params) {
            try {
                const res = await ArrivalService.cancelArrival(url, params)
                return res.data;
            } catch (e) {
                return e;
            }
        },
    }
})
